import React from 'react';
import { Col } from 'react-bootstrap';

const OuritemReusable = ({ img }) => {
  return (
    <Col  xs={6} lg={4} sm={6} md={4}>
        <div className="our_item">
          <div className="our_item_mane">
            <img src={img} className="w-100" alt="" />
              <ul>                           
                  <li class="icon_star"><i class="fa-solid fa-star"></i></li>
                  <li class="icon_star"><i class="fa-solid fa-star"></i></li>
                  <li class="icon_star"><i class="fa-solid fa-star"></i></li>
                  <li class="icon_star"><i class="fa-solid fa-star"></i></li>
                  <li class="icon_star"><i class="fa-solid fa-star"></i></li>
              </ul>
          </div>
          <div class="our_item_text">
              <h3 class="item-name">Organic Vegetables</h3>
              <h5 class="item-price">$8.00-9.00</h5>
          </div>                 
        </div>
    </Col>
  )
}

export default OuritemReusable